import { useEffect } from "react";
import { App as CapApp } from "@capacitor/app";

export default function useBackButton(handler) {
    useEffect(() => {
        let listenerHandle;

        // Register listener
        const setup = async () => {
            listenerHandle = await CapApp.addListener("backButton", handler);
        };

        setup();

        // Cleanup
        return () => {
            if (listenerHandle) {
                listenerHandle.remove();
            }
        };
    }, [handler]);
}
